import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AgGridAngular } from 'ag-grid-angular';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { distribuidorModulo } from '../../diccionarios/distribuidorModulo';
import { DistribuidorMantenedorModel, DistriMantenedorInterface } from '../../models/distribuidorMantenedorModel';
import { DistribuidorService } from '../../services/distribuidor.service';

@Component({
  selector: 'app-mantenedor-distribuidor',
  templateUrl: './mantenedor-distribuidor.component.html',
  styleUrls: ['./mantenedor-distribuidor.component.css']
})
export class MantenedorDistribuidorComponent implements OnInit {

  tituloCard: string = 'Mantenedor Distribuidor';
  tituloForm: string;
  //formulario
  formulario: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  //componentes del grid
  @ViewChild('agGrid') agGrid: AgGridAngular;
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;

  //buscador grid
  textoBuscar: string;

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;
  textBoton: string;

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;

  distribuidorModulo: any = {};
  modelGridDistribuidor: DistriMantenedorInterface;

  constructor(private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _distribuidor: DistribuidorService) { }

  ngOnInit() {
    this.distribuidorModulo = distribuidorModulo;
    this.DAT_BTNS = this.distribuidorModulo.button.buttonsNombre;
    this.DAT_MSG = this.distribuidorModulo.mensajes;
    this.DAT_BTNCSS = this.distribuidorModulo.button.buttonsCss;

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    const innClase = new DistribuidorMantenedorModel();
    this.modelGridDistribuidor = innClase.devolverModeloGridMantenedor();

    this.formulario = this.fb.group({
      idDistribuidor: ['', [Validators.required, Validators.maxLength(10)]],
      nombreDistribuidor: ['', [Validators.required, Validators.maxLength(50)]],
      ruc: ['', [Validators.required, Validators.maxLength(20)]],
      idVendedor: ['', [Validators.required, Validators.maxLength(10)]],
      efectividad: ['', [Validators.required, Validators.maxLength(2)]],
      email: ['', [Validators.required, Validators.email]]
    });
    
    this.cargarGridcomponent();
    this.getDistribuidor();
  }

  cargarGridcomponent() {
    this.columnDefs = [
      {
        headerName: 'COD.DISTRIBUIDOR',
        field: this.modelGridDistribuidor.idDistribuidor,
        // lockPosition: true,
        // resizable: true,
        width: 180,
        sortable: true
      },
      {
        headerName: 'NOMBRE.DISTRI',
        field: this.modelGridDistribuidor.nombreDistribuidor,
        // lockPosition: true,
        // resizable: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'RUC.DISTRI',
        field: this.modelGridDistribuidor.ruc,
        // lockPosition: true,
        // resizable: true,
        width: 150,
        sortable: true
      },
      // {
      //   headerName: 'EFECTIVIDAD',
      //   field: this.modelGridDistribuidor.efectividad,
      //   // lockPosition: true,
      //   // resizable: true,
      //   width: 150,
      //   sortable: true
      // },
      {
        headerName: 'VENDEDOR',
        field: this.modelGridDistribuidor.idVendedor,
        // lockPosition: true,
        // resizable: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'EMAIL',
        field: this.modelGridDistribuidor.email,
        // lockPosition: true,
        // resizable: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'TELEFONO',
        field: this.modelGridDistribuidor.telefono,
        // lockPosition: true,
        // resizable: true,
        width: 150,
        sortable: true
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];
    this.rowSelection = 'multiple';
  }

  getDistribuidor() {
    this.loading = true;
    this._distribuidor.getDistribuidor().subscribe((res:any[]) => {
      this.loading = false;
      this.rowData = res;
      this.listaVacia = (this.rowData.length === 0)? true : false;
    }, (err:any) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowData = [];
      console.log(err);
      this._utils.mensajeErrorVisto(err.error.mensaje);
    });
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  nuevo() {
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Guardar Distribuidor';
    this.formulario.get('efectividad').setValue(85);
  }

  editar({rowData}) {
    delete rowData['idDistribuidorTRIM'];
    delete rowData['telefono'];
    this.commonFormService.abrirFormularioParaEditar(this, rowData);
    this.textBoton = this.DAT_BTNS.editar;
    this.tituloForm = 'Editar Distribuidor';
    this.formulario.get('efectividad').setValue(85);
  }
  
  eliminar({rowData}) { //ilzambrano
    // this._utils.confirmarAcyncronico(this, {title: this.DAT_MSG.eliminar, text: ``, action: this.DAT_BTNS.eliminar}, () => {
    //   return this._distribuidor.deleteDistribuidor(rowData.idDistribuidor);
    // }, () => {
    //   this.gridApi.updateRowData({ remove: this.gridApi.getSelectedRows() });
    // });
  }

  guardar() {
    this._utils.confirmarSincronoPromesaNormal(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._distribuidor.postDistribuidor(this.formulario.value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.mostrarFormulario = false;
      this.formulario.reset();
      this.getDistribuidor();
    }).catch((err) => {
      this._utils.mensajeErroToast(err.error.mensaje, 5000);
    });
  }

  actualizar() {
    this._utils.confirmarSincronoPromesaNormal(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._distribuidor.putDistribuidor(this.formulario.value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.mostrarFormulario = false;
      this.formulario.reset();
      this.getDistribuidor();
    }).catch((err) => {
      this._utils.mensajeErroToast(err.error.mensaje, 5000);
    });
  }

  acciones(event) {
    // debugger
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizar();
      } else {
        this.guardar();
      }
    } else {
      this.mostrarFormulario = false;
    }
  }

}
